import React from "react";
import classes from "./FooterUtilityBar.module.scss";
import { Container } from "react-bootstrap";
import CustomLink from "../../CustomLink";

const FooterUtilityBar: React.FC<{ footerData: any }> = ({ footerData }) => {
  return (
    <Container>
      <div className={classes.lineBottom} />
      <div id="publicLinks" className={classes.publicLinks}>
        <div className={classes.socialMediaLink}>
          {footerData?.socialLink?.length > 0 &&
            footerData?.socialLink.map((link: any) => {
              return (
                <CustomLink data={link} key={link.id}>
                  <img src={link?.image?.url || "/"} alt={link?.image?.alternativeText || `alt-image-social-${link.id}`} width={40} height={40} />
                </CustomLink>
              );
            })}
        </div>
        <div className={classes.terms}>
          <div>{footerData?.copyright || ""}</div>
          {footerData?.bottomLinks?.length > 0 &&
            footerData?.bottomLinks.map((terms: any) => (
              <div key={terms.id}>
                <CustomLink data={terms}>{terms.label}</CustomLink>
              </div>
            ))}
        </div>
      </div>
    </Container>
  );
};
export default FooterUtilityBar;
